export const mixin_layerMove = {
    data() {
        return {
            position: { x: 0, y: 0 },
            isDragging: false,
            dragOffset: { x: 0, y: 0 },
        };
    },
    computed: {
        elementStyle() {
            return {
                transform: `translate(${this.position.x}px, ${this.position.y}px)`,
            };
        },
    },
    created() { },
    mounted() {
        document.addEventListener('mousemove', this.onDrag);
        document.addEventListener('mouseup', this.stopDrag);
    },
    methods: {
        startDrag(event) {
            event.preventDefault();
            const scrollX = window.pageXOffset || document.documentElement.scrollLeft || 0;
            const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

            // 正确计算偏移量
            this.dragOffset.x = event.clientX - this.position.x + scrollX;
            this.dragOffset.y = event.clientY - this.position.y + scrollY;
            this.isDragging = true;
        },
        onDrag(event) {
            if (this.isDragging) {
                event.preventDefault();
                if (document.querySelector('.layerHeader')) {
                    document.querySelector('.layerHeader').style.cursor = 'move';
                }
                const scrollX = window.pageXOffset || document.documentElement.scrollLeft || 0;
                const scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

                // 更新位置
                this.position.x = event.clientX - this.dragOffset.x + scrollX;
                this.position.y = event.clientY - this.dragOffset.y + scrollY;
            }
        },
        stopDrag() {
            this.isDragging = false;
            if (document.querySelector('.layerHeader')) {
                document.querySelector('.layerHeader').style.cursor = 'grab';
            }
        },
    },
    beforeDestroy() {
        document.removeEventListener('mousemove', this.onDrag);
        document.removeEventListener('mouseup', this.stopDrag);
    },
};